export default __webpack_public_path__ + "468c8be3740e6236bec4b3a09bd07d94.otf";